export default __webpack_public_path__ + "static/media/teacher-sample.4592f51b.zip";